import clsx from 'clsx';
import { FC, ReactNode } from 'react';
import styles from './Button.module.scss';
import { Link } from 'react-router-dom';

export interface IButtonProps {
  children: ReactNode;
  className?: string;
  href?: string;
  onClick?: () => void;
}

export const Button: FC<IButtonProps> = (props) => {
  const { children, className, href, onClick } = props;

  if (href) {
    return (
      <Link
        to={href}
        onClick={onClick}
        className={clsx(styles.Button, className)}
      >
        {children}
      </Link>
    );
  }

  return (
    <button onClick={onClick} className={clsx(styles.Button, className)}>
      {children}
    </button>
  );
};
